import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/Features/FTP/SuccessBox';
import FTPTable from 'components/Web_User_Interface/1080p_Series/Features/FTP/ftpTable';
import PrimaryBox from 'components/Web_User_Interface/1080p_Series/Features/FTP/PrimaryBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  FTPTable,
  PrimaryBox,
  BreadCrumbs,
  SEOHelmet,
  React
};